"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiomSdkCore = void 0;
const internalConfig_1 = require("./internalConfig");
const block_1 = require("./block");
const abi_1 = require("./lib/abi");
const queryV2_1 = require("../v2/query/queryV2");
class AxiomSdkCore {
    constructor(config, overrides) {
        this.config = new internalConfig_1.InternalConfig(config, overrides);
        switch (this.config.version) {
            case "v2":
                this.block = new block_1.Block(this.config);
                this.query = new queryV2_1.QueryV2(this.config);
                break;
            default:
                throw new Error(`Invalid version detected: ${this.config.version}`);
        }
    }
    getAxiomQueryAbi() {
        return (0, abi_1.getAxiomQueryAbiForVersion)(this.config.version);
    }
    getAxiomQueryAddress() {
        return this.config.getConstants().Addresses.AxiomQuery;
    }
}
exports.AxiomSdkCore = AxiomSdkCore;
//# sourceMappingURL=axiom.js.map